import React from 'react';
import { Box, TextButton } from '@wix/design-system';
import { WidgetLayout } from '../../../CommonWidgets/shared/WidgetLayout/WidgetLayout';
import { useDisabledWidget } from '../../../../shared/disabled-widget/useDisabledWidget';
import { StyledMarkdownText } from '../../ProactiveMarketingAssistant/common/TextTyper/StyledMarkdownText';
import { ExternalLink } from '@wix/wix-ui-icons-common';
import styles from './VeloFallbackWidget.module.scss';
export const VeloFallbackWidget = _ref => {
  let {
    data: {
      content,
      links
    },
    context,
    config
  } = _ref;
  const {
    emitSideEffect
  } = context;
  const {
    areControlsDisabled,
    enableControls
  } = useDisabledWidget(config);
  const handleLinkClick = link => {
    if (link.sideEffect) {
      emitSideEffect(link.sideEffect.name, link.sideEffect.params);
    }
    window.open(link.url, '_blank');
  };
  return /*#__PURE__*/React.createElement(WidgetLayout, {
    context: context,
    disabled: areControlsDisabled,
    onEnableControls: enableControls
  }, content && /*#__PURE__*/React.createElement(StyledMarkdownText, {
    className: styles.contentContainer
  }, content), links && !!links.length && /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "15px"
  }, links.map((link, index) => /*#__PURE__*/React.createElement(TextButton, {
    key: index,
    size: "tiny",
    priority: "secondary",
    onClick: () => handleLinkClick(link),
    dataHook: `fallback-link-${index}`,
    suffixIcon: /*#__PURE__*/React.createElement(ExternalLink, null)
  }, link.label))));
};
export const VELO_FALLBACK_WIDGET = 'VELO_FALLBACK_WIDGET';
//# sourceMappingURL=VeloFallbackWidget.js.map